var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled, { ThemeProvider } from "styled-components";
import { Heading4 } from '../doconHeadings/doconHeadings';
import { CrossIcon } from '../../shared/icons';
import { FlexBox, CenterBox } from '../../shared/Element';
import { doconTheme } from "../../../theme/default";
var handleColor = function (_a) {
    var theme = _a.theme;
    var colors = theme.v2.colors;
    return "\n    background-color: " + colors.blueColor[3] + ";\n    color: " + colors.text.secondaryColor + ";\n    --close-bg: " + colors.white + ";\n    :hover {\n      color: " + colors.text.primaryColor + ";\n    }\n  ";
};
var Root = styled(FlexBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: fit-content;\n  border-radius: 16px;\n  align-items: center;\n  cursor: pointer;\n  ", ";\n  ", " {\n    font-weight:500;\n    text-transform: capitalize;\n    color: currentColor;\n  }\n"], ["\n  width: fit-content;\n  border-radius: 16px;\n  align-items: center;\n  cursor: pointer;\n  ", ";\n  ", " {\n    font-weight:500;\n    text-transform: capitalize;\n    color: currentColor;\n  }\n"])), function (props) { return handleColor(props); }, Heading4);
var Close = styled(CenterBox)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: 8px;\n  border-radius: 50%;\n  background-color: var(--close-bg);\n  :hover {\n    transform: scale(1.1);\n  }\n"], ["\n  margin-left: 8px;\n  border-radius: 50%;\n  background-color: var(--close-bg);\n  :hover {\n    transform: scale(1.1);\n  }\n"])));
function DoconTag(_a) {
    var id = _a.id, label = _a.label, onDelete = _a.onDelete, onClick = _a.onClick, props = __rest(_a, ["id", "label", "onDelete", "onClick"]);
    function handleClick(e) {
        e.stopPropagation();
        onClick && onClick({ label: label, id: id });
    }
    function handleIconClick(e) {
        e.stopPropagation();
        onDelete && onDelete({ id: id });
    }
    return (React.createElement(ThemeProvider, { theme: doconTheme },
        React.createElement(Root, __assign({ p: '8px 12px' }, props, { onClick: handleClick }),
            React.createElement(Heading4, { tagAs: 'div', title: label }),
            React.createElement(Close, { size: 20, onClick: handleIconClick },
                React.createElement(CrossIcon, { width: 10 })))));
}
export default styled(DoconTag)(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2, templateObject_3;
